module.exports = __webpack_public_path__ + "static/img/prize-img1.35e0884.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize-img1.png
// module id = 7jeN
// module chunks = 1